import axios from 'axios';

import {config} from '../config';
import {auth} from "@/firebase.config";

import {getStorage, ref, uploadBytesResumable, getDownloadURL, getMetadata} from "firebase/storage";

export async function updateProfileImageLink(data) {
    const host = `${config.service.host}/api`;
    const accessToken = await auth.currentUser.getIdToken(true);
    const response = await axios.post(
        `${host}/user/profile_image/` + auth.currentUser.uid,
        {
            data
        },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
}

export async function getProfileImageLink() {
    const host = `${config.service.host}/api`;
    const accessToken = await auth.currentUser.getIdToken(true);
    const response = await axios.get(
        `${host}/user/profile_image/` + auth.currentUser.uid,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
}


// Resolves once the upload finishes and rejects if it fails, so callers can
// report the real outcome. The Resize Images extension then writes
// profile/{uid}_224x224, which is what every page displays.
export function updateProfileImage(file) {
    const storage = getStorage();
    const storageRef = ref(storage, 'profile/' + auth.currentUser.uid);
    return new Promise((resolve, reject) => {
        uploadBytesResumable(storageRef, file).on('state_changed', null, reject, resolve);
    });
}

// The resized photo's URL, or null when the user has none. The download URL
// stays the same when a photo is replaced, so `v` (last update time) makes the
// browser fetch the new one instead of showing a cached copy.
export async function findProfileImage(uid) {
    if (!uid) return null;
    const imageRef = ref(getStorage(), `profile/${uid}_224x224`);
    try {
        const [url, metadata] = await Promise.all([getDownloadURL(imageRef), getMetadata(imageRef)]);
        return `${url}&v=${encodeURIComponent(metadata.updated)}`;
    } catch (e) {
        return null;
    }
}

export async function getProfileImage(uid) {
    const defaultUrl = new URL("../assets/profile.jpeg", import.meta.url).href;
    return (await findProfileImage(uid)) || defaultUrl;
}
